import { Box, Flex, Input, Text } from "@chakra-ui/react";
import {
	forwardRef,
	useCallback,
	useImperativeHandle,
	useRef,
	useState,
} from "react";

export type TemporaryFile = {
	id?: number;
	name: string;
};

interface FileInlineInputProps {
	name: string;
	display?: string;
	fileName?: string;
	files?: TemporaryFile[];
	onFileChange?: (files: File[] | null) => void;
	onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
	onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
	accept?: string;
}

const FileInlineInput = forwardRef<HTMLInputElement, FileInlineInputProps>(
	(
		{
			name,
			files,
			onFileChange,
			onChange,
			onBlur,
			display,
			accept,
			fileName = undefined,
		},
		ref,
	) => {
		const [file, setFile] = useState<File | TemporaryFile | null>(
			Array.isArray(files) && files.length > 0 ? files[0] : null,
		);
		const inputRef = useRef<HTMLInputElement>(null);
		useImperativeHandle(ref, () => inputRef.current!, []);

		const handleOnInput = useCallback(() => {
			if (onFileChange) {
				if (inputRef.current?.files) {
					const currentFiles = Array.from(inputRef.current.files).slice(0, 1);
					if (currentFiles.length === 0 && file) {
						return;
					}
					onFileChange(currentFiles);
					setFile(currentFiles[0]);
				} else {
					// onFileChange(null);
				}
			}
		}, [onFileChange, file]);

		return (
			<Flex
				display={display}
				position="relative"
				bg="white"
				border="solid 1px"
				borderColor="gray.200"
				borderRadius="lg"
				justifyContent={"center"}
				direction={"column"}
				alignItems={"center"}
				h="2.5rem"
				w={"100%"}
				onClick={() => {
					if (inputRef.current) {
						inputRef.current.click();
					}
				}}
				onDragOver={(event) => {
					event.stopPropagation();
					event.preventDefault();
				}}
				onDrop={(event) => {
					event.preventDefault();
					if (inputRef.current) {
						inputRef.current.files = event.dataTransfer.files;
						if (onFileChange) {
							onFileChange(Array.from(inputRef.current.files).slice(0, 1));
						}
					}
				}}
			>
				<Input
					ref={inputRef}
					type="file"
					name={name}
					display={"none"}
					onInput={handleOnInput}
					onChange={onChange}
					onBlur={onBlur}
					accept={accept}
				></Input>
				<Box position="absolute" left="1rem" color="gray.500">
					<Text>Fichier sélectionné</Text>
				</Box>
				{file && (
					<Box position="absolute" right="1rem">
						<Text>{fileName ?? file.name}</Text>
					</Box>
				)}
			</Flex>
		);
	},
);

export default FileInlineInput;
